<template>
  <h3>Tetris with vue</h3>
  <div class="line" v-for="(_,i) in 20" :key="i">
    <div class="cell" v-for="(_,j) in 10" :key="j" :class="cells[i][j]">
      
    </div> 
  </div>
  <p>조작:⬅️,⬇️,➡️ | 회전:⬆️,Lctrl | 놓기:Space</p>
  <!-- <button class = "conroller" @click="this.moveBlock([-1,0])">⬅️</button>
  <button class = "conroller" @click="this.moveBlock([1,0])">➡️</button>
  <button class = "conroller" @click="this.moveBlock([0,1])">⬇️</button>
  <button class = "conroller" @click="this.spinBlock(1)">↪️</button>
  <button class = "conroller" @click="this.spinBlock(-1)">↩️</button>
  <button class = "conroller" @click="this.moveBlock([0,0])">⏬</button> -->

</template>

<script>
import blocks from "./assets/blocks.js"

//T,L,J,O,I,S,Z
export default {
  name: 'App',
  data(){
    return{
      types:['O','I','S','Z','L','J','T'],
      bag:['O','I','S','Z','L','J','T'],
      blocks:blocks,
      downInterval:'',
      colors:{'O':'yellow','I':'skyblue','S':'green','Z':'red','L':'orange','J':'blue','T':'purple'},
      cerBag:0,
      cerBlock:'T',
      cerDir:0,
      cerPos:[-1,3],
      cerColor:'blue',
      stopStack:0,
      cells:Array.from({length:20},()=>{return Array.from({length:10},()=>{return 'white'})})}
  },
  methods:{
    setBlock(type,pos,dir,color){
      const selBlock = blocks[type][dir]
      for(let i=0;i<4;i++){
        for(let j=0;j<4;j++){
          if(selBlock[i][j] === 1){
            this.cells[pos[0]+i][pos[1]+j] = color;
          }
        }
      }
    },
    moveBlock(pos){
      const targetPos = [this.cerPos[0] + pos[0],this.cerPos[1] + pos[1]]
      if(this.testOverlap(this.cerBlock,targetPos,this.cerDir)){
        this.setBlock(this.cerBlock,this.cerPos,this.cerDir,'white');
        this.cerPos = targetPos;
        this.setBlock(this.cerBlock,this.cerPos,this.cerDir,this.cerColor);
        return true;
      }
      return false;
    },
    spinBlock(dir){
      const targetDir = (this.cerDir + 4 + dir) % 4;
      if(this.testOverlap(this.cerBlock,this.cerPos,targetDir)){
        this.setBlock(this.cerBlock,this.cerPos,this.cerDir,'white');
        this.cerDir = targetDir;
        this.setBlock(this.cerBlock,this.cerPos,this.cerDir,this.cerColor);
        return true;
      }
      return false;

    },
    putBlock(){
      let a = this.moveBlock([1,0]);
      while(a){
        a = this.moveBlock([1,0]);
      }
      this.resetBlock();
    },
    delLine(){
      let targetLine=[];
      for(let i=0;i<20;i++){     
        let count = 0
        for(let j = 0;j<10;j++){
          if(this.cells[i][j]==='gray'){
            count++;
          }
        }
        if(count===10){
          targetLine.push(i);
        }
      }
      console.log(targetLine);
      for(let i=targetLine.length-1;i>=0;i--){
        this.cells.splice(targetLine[i],1);
      }
      for(let i=0;i<targetLine.length;i++){
        this.cells.unshift(Array.from({length:10},()=>{return 'white'}));
      }
    },
    resetBlock(){
      clearInterval(this.downInterval);
      this.setBlock(this.cerBlock,this.cerPos,this.cerDir,'gray');
      this.delLine();      
      this.cerBag += 1;
      if(this.cerBag > 6){
        this.bag.sort(() => Math.random() - 0.5);
        this.cerBag = 0;
      }
      this.cerBlock = this.bag[this.cerBag];
      this.cerColor = this.colors[this.cerBlock];
      this.cerDir = 0;
      this.cerPos = [-1,3];
      this.stopStack = 0;
      this.setBlock(this.cerBlock,this.cerPos,this.cerDir,this.cerColor);
      this.downInterval = setInterval(this.blockDown, 500);
    },
    blockDown(){
      if(this.moveBlock([1,0])){
        this.stopStack = 0;
      }else{
        this.stopStack +=1;
      }
      if(this.stopStack > 1){
        
        this.resetBlock();
      }
    },
    resetGame(){
      this.bag.sort(() => Math.random() - 0.5);
      this.cerBlock = this.bag[this.cerBag];
      this.cerColor = this.colors[this.cerBlock];
      this.setBlock(this.cerBlock,this.cerPos,this.cerDir,this.cerColor);
      this.downInterval = setInterval(this.blockDown, 500);
      
    },
    testOverlap(type,pos,dir){
      const selBlock = blocks[type][dir]
      for(let i=0;i<4;i++){
        for(let j=0;j<4;j++){
          if(selBlock[i][j] === 1){
            if(0>pos[0]+i || pos[0]+i>19 || 0>pos[1]+j || pos[1]+j>9){
              return false;
            }
            if(this.cells[pos[0]+i][pos[1]+j] === 'gray'){
                return false;
              }

          } 
        }
      }
      return true;
    }
  },
  mounted(){
    document.querySelector('body').addEventListener('keydown',(e)=>{
      switch(e.code){
        case "ArrowRight":
          this.moveBlock([0,1]);
          break;
        case "ArrowLeft":
          this.moveBlock([0,-1])
          break;
        case "ArrowDown":
          this.moveBlock([1,0])
          
          break;
        case "ArrowUp":
          this.spinBlock(-1)
          break;
        case "ControlLeft":
          this.spinBlock(1)
          break;
        case "Space":
          this.putBlock();
          break;

      }
    });
    this.resetGame();
    

  },
  components: {
  }
}
</script>

<style>
.cell{
  width:40px;
  height:40px;
  background-color:beige;
  outline: solid black;
  outline-width: 1px;
  display:inline-block;
  margin:-1px;
}

p{
  margin:-1px;
}

.blue{
  background-color: blue;
}
.orange{
  background-color: orange;
}
.skyblue{
  background-color: skyblue;
}
.yellow{
  background-color: yellow;
}
.red{
  background-color: red;
}
.green{
  background-color: lime;
}
.purple{
  background-color: purple;
}
.gray{
  background-color: gray;
}

.line{
  margin:-1px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
